import { z } from "zod";

export const geoCoordinatesSchema = {
	coordinates: z
		.object({
			latitude: z.number(),
			longitude: z.number(),
		})
		.optional(),
};
